import type { IconSvgObject } from './types';

const SwissFrancIcon: IconSvgObject = [
  ["path", { d: "M18 3H16C13.1716 3 11.7574 3 10.8787 3.87868C10 4.75736 10 6.17157 10 9V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 10H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 16H6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SwissFrancIcon;
